import PT from "prop-types";
import UusimmatChild from "../uusimmat/uusimmat-child";
import React, { useEffect, useState } from "react";
import { ShowMoreBtn } from "../../atoms/show-more-btn";

import "./video-list.m.css";

const VideoList = () => {
  const [loadMore, setLoadMore] = useState(5);
  const [videot, setVideoList] = useState([]);
  var [showBtn, setShowBtn] = useState(true);
  useEffect(() => {
    async function fetchAPI() {
      await fetch(`/api/v1/collections/videot-ilkka-pohjalainen`)
        .then((res) => res.json())
        .then((json) => setVideoList(json.items))
    }
    fetchAPI();

  }, [])

  const videolist = [...videot && videot.filter(item => item.type === "story") || []];
  if (videolist.length < 1) {
    return null;
  }

  const handleLoadMore = () => {
    setLoadMore(loadMore + 5);
    if (videolist.length <= (loadMore + 5)) setShowBtn(false);
  }

  return (
    <React.Fragment>
      <div styleName="videolist-sidebar-global">
        <h2 className="top-headline top-headline-videot" styleName="top-headline">Videot</h2>
        <div>
          {videolist
            .slice(0, loadMore)
            .map((item, index) => <div key={index}><UusimmatChild item={item} /></div>)}
          {(showBtn === true && videolist.length > 5) &&
            <ShowMoreBtn loadMore={handleLoadMore} btnName="NÄYTÄ LISÄÄ" />
          }
        </div>
      </div>
    </React.Fragment>
  );
};

VideoList.propTypes = {
  collectionslug: PT.string
};

export default VideoList;
